'use client';

import React from 'react';
import ContactPage from '@/app/components/ContactPage';

// This component now contains the client-side logic and rendering
export default function ContactClient() {
  return (
    <div className="min-h-screen bg-[#0c0c0c]">
      <ContactPage />
    </div>
  );
} 